import { render, staticRenderFns } from "./Feedback.vue?vue&type=template&id=85b117a0"
import script from "./Feedback.vue?vue&type=script&lang=js"
export * from "./Feedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85b117a0')) {
      api.createRecord('85b117a0', component.options)
    } else {
      api.reload('85b117a0', component.options)
    }
    module.hot.accept("./Feedback.vue?vue&type=template&id=85b117a0", function () {
      api.rerender('85b117a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bookkeeping/Feedback.vue"
export default component.exports